import React from 'react';

const MarketPanelSectorWatch = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Sector Watch</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="sector-watch">
            <thead>
              <tr>
                <th>Sector</th>
                <th>Current Value</th>
                <th>Change</th>
                <th>% Change</th>
                <th>High</th>
                <th>Low</th>
                <th>Open</th>
                <th>Prev. Close</th>
                <th>Volume</th>
                <th>Turnover (₹ Cr)</th>
                <th>Top Gainers</th>
                <th>Top Losers</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.sector || '-'}</td>
                    <td>{item.current_value || '-'}</td>
                    <td>{item.change || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.high || '-'}</td>
                    <td>{item.low || '-'}</td>
                    <td>{item.open || '-'}</td>
                    <td>{item.prev_close || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.turnover || '-'}</td>
                    <td>{item.top_gainers || '-'}</td>
                    <td>{item.top_losers || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelSectorWatch; 